module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image14g.6c883629.jpg";